import { MapPin, Clock, Phone, Navigation } from 'lucide-react';
import { officeLocations } from '../data';

export default function InteractiveMap() {
  const office = officeLocations[0];

  return (
    <section className="relative">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
        {/* Map embed */}
        <div className="lg:col-span-3 relative rounded-2xl overflow-hidden border border-[#c9a84c]/15 h-[400px]">
          <iframe
            title="Office Location"
            width="100%"
            height="100%"
            frameBorder="0"
            scrolling="no"
            src={`https://www.openstreetmap.org/export/embed.html?bbox=-74.0545,40.7252,-74.0465,40.7312&layer=mapnik&marker=${office.lat},${office.lng}`}
            className="grayscale-[30%] contrast-[1.1]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0a1628] via-transparent to-transparent pointer-events-none" />
          <div className="absolute bottom-4 left-4 right-4">
            <div className="glass rounded-xl p-4 flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-[#c9a84c]/20 flex items-center justify-center shrink-0">
                <MapPin className="w-5 h-5 text-[#c9a84c]" />
              </div>
              <div>
                <p className="text-sm font-semibold text-[#e8e4dc]">{office.name}</p>
                <p className="text-xs text-[#e8e4dc]/60">{office.address}, {office.city}, {office.state} {office.zip}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Info card */}
        <div className="lg:col-span-2 flex flex-col gap-4">
          <div className="flex-1 p-6 rounded-2xl bg-gradient-to-b from-[#0f2240]/60 to-[#0a1628]/60 border border-[#c9a84c]/10">
            <h3 className="text-lg font-bold text-[#e8e4dc] mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              Visit Our Office
            </h3>
            <div className="space-y-5">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[#c9a84c]/10 flex items-center justify-center shrink-0">
                  <MapPin className="w-5 h-5 text-[#c9a84c]" />
                </div>
                <div>
                  <p className="text-sm font-medium text-[#e8e4dc]">{office.address}</p>
                  <p className="text-sm text-[#e8e4dc]/60">{office.city}, {office.state} {office.zip}</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[#c9a84c]/10 flex items-center justify-center shrink-0">
                  <Phone className="w-5 h-5 text-[#c9a84c]" />
                </div>
                <div>
                  <p className="text-sm font-medium text-[#e8e4dc]">{office.phone}</p>
                  <p className="text-sm text-[#e8e4dc]/60">Call for appointments</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[#c9a84c]/10 flex items-center justify-center shrink-0">
                  <Clock className="w-5 h-5 text-[#c9a84c]" />
                </div>
                <div>
                  <p className="text-sm font-medium text-[#e8e4dc]">{office.hours}</p>
                  <p className="text-sm text-[#e8e4dc]/60">Saturday by appointment</p>
                </div>
              </div>
            </div>
          </div>
          <a
            href={`https://www.google.com/maps/dir/?api=1&destination=${office.lat},${office.lng}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 px-6 py-4 rounded-2xl bg-gradient-to-r from-[#c9a84c] to-[#b08e2e] text-[#0a1628] font-semibold text-sm hover:shadow-lg hover:shadow-[#c9a84c]/20 transition-all duration-300 hover:scale-[1.02]"
          >
            <Navigation className="w-4 h-4" />
            Get Directions
          </a>
        </div>
      </div>
    </section>
  );
}
